const md5 = require('md5')

const getConferenceRoomId = id => {
  return md5(String(id))
}

export default getConferenceRoomId